import styled from 'styled-components';

export const SectionElementAnimatedContainer = styled.div`
  overflow: hidden;
  display: grid;

  > .animated-content {
    opacity: 0; // for initial static html render, it gets overriden after hydration by gsap
    grid-area: 1 / 1;
  }
`;
